module.exports = __webpack_public_path__ + "static/media/no-movie-icon.fa66f791.svg";